export const FACULTY_COLORS = {
  A: "#7f5937",  // Arquitectura
  I: "#203a8f",  // Ciencias de la Comunicación
  E: "#828bbc",  // Ciencias de la Educación y Psicopedagogía
  C: "#cd8b21",  // Ciencias Económicas
  J: "#b01629",  // Derecho y Ciencias Políticas
  M: "#f1c537",  // Medicina y Ciencias de la Salud
  D: "#7a9221",  // Motricidad Humana y Deportes
  P: "#63376f",  // Psicología y Relaciones Humanas
  T: "#676c6f",  // Tecnología Informática
  H: "#930072",  // Turismo y Hospitalidad
}